/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    API_STATUS_CODE,
    AddToCartType,
    CouponType,
    GiftType,
    ProductStockStatus,
    SHIPPING_METHOD,
    SaleChannel,
    ServiceType,
} from '@/constants'
import { useAuth, useStore } from '@/containers'
import { useProductContext } from '@/context'
import { IconCheckedSuccess, IconErrorMessage } from '@/styles/Icon'
import type {
    GiftItems,
    OrderService,
    OtherOffers,
    Product,
    ProductDetail,
    VoucherItem,
} from '@/types'
import { useRouter } from 'next/router'
import { useMemo, type Dispatch, type SetStateAction } from 'react'
import { toast } from 'react-toastify'
import ProductButton from './ButtonProduct'
interface Props {
  cartLoading: boolean
  isPreOrder: boolean
  addToCartData: ProductDetail
  checkSaleArea: boolean
  setIsOpenAddToCart?: Dispatch<SetStateAction<boolean>>
  setIsOpenContact?: Dispatch<SetStateAction<boolean>>
  listService?: OrderService[]
  listGift?: GiftItems[] | undefined
  // setListOffer: Dispatch<SetStateAction<OtherOffers[] | undefined>>
  listOffer?: OtherOffers[] | undefined
  pickUpInStore: boolean
  listBundleSelected: Product[]
  setPickUpInStore: Dispatch<SetStateAction<boolean>>
  handleAddBundleToCart: (product: any, type: string) => Promise<any>
  handleAddToCart: (
    product: Product | ProductDetail,
    type: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => Promise<any>
}

const FooterProductDetail = ({
  addToCartData,
  handleAddToCart,
  handleAddBundleToCart,
  setIsOpenContact,
  listService,
  listGift,
  listOffer,
  cartLoading,
  isPreOrder = false,
  pickUpInStore,
  listBundleSelected,
}: Props) => {
  const router = useRouter()
  const { setVoucherChoose, setIsVoucherLoginOpen } = useProductContext()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { cart, fetchCart, channel, token, setVoucherApply } = useAuth()
  const listBundleProduct = listBundleSelected?.map(item => {
    return { productId: item._id, quantity: 1 }
  })

  const { selectedLang } = useStore()


  const isInstallment = addToCartData?.finalPrice >= 3000000
  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'USD'
      default:
        return 'VND'
    }
  }
  const dataProduct = {
    ...addToCartData,
    receiveAtWarehouse: pickUpInStore,
    selectedReceiveAtWarehouse: pickUpInStore,
    addGift: listGift?.filter(e => e._id).map(item => {
      if (item.optionBuy) {
        if (item.type === GiftType.OTHER && item.giftType === 'byProduct') {
          return {
            _id: item._id,
            checked: item.calToCart,
          }
        }
        return {
          _id: item._id,
          checked: item.checked,
        }
      }
      if (!item.optionBuy) {
        if (item.calToCart) {
          return {
            _id: item._id,
            checked: true,
          }
        }
      }
      if (item.type == CouponType.COUPON) {
        return {
          _id: item._id,
          checked: true,
        }
      }

      return {
        _id: item._id,
        checked: false,
      }
    }),
    addService: listService?.filter(e => e.active).map(item => item._id),
    addOffer: listOffer?.map(item => ({
      _id: item?.content?._id,
      checked: item.active,
    })),
    shippingMethod: listService?.find(
      e =>
        (e.type === ServiceType.SHIPPING ||
          e.type === ServiceType.SHIPPING_AND_INSTALL) &&
        e.active
    )
      ? SHIPPING_METHOD.STANDARD
      : SHIPPING_METHOD.PICKUP_IN_STORE,
  } as Product | ProductDetail

  const finalPriceButton = () => {
    let finalPrice = dataProduct.finalPrice;
    const total = listService
      ?.filter(e => e.active)
      .reduce((sum, item) => sum + item.price, 0);
    if(total) {
      finalPrice += total
    }
    if(listGift) {
      const totalPriceGift = listGift.filter(item => item.optionBuy && !item.checked).reduce((sum, item) => sum + item.price, 0);
      if(totalPriceGift) {
        finalPrice = finalPrice - totalPriceGift
      }
    }
    if (listBundleSelected && listBundleSelected?.length > 0) {
      const totalPriceBundle = listBundleSelected.reduce((sum, item) => sum + item.finalPrice, 0);
      if(totalPriceBundle) {
        finalPrice = finalPrice + totalPriceBundle
      }
    }

    return finalPrice;
  }

  const checkFSSale = () => {
    if(cart && cart.products.length > 0) {
      const cartP = cart.products.find(item => addToCartData._id === item._id);
      if(cartP) {
        if(addToCartData?.limitSale && addToCartData?.limitSale < (cartP.quantity +1) ) {
          toast.error(`Bạn chỉ có thể mua ${addToCartData?.limitSale} sản phẩm`, {
              position: 'bottom-center',
              icon: <IconErrorMessage />,
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: 'dark',
            })
            return false
        }
        if(cartP.flashSale && (cartP.flashSale.soldQuantity + cartP.quantity +1) > cartP.flashSale.quantity ) {
          toast.error(`Bạn chỉ có thể mua ${addToCartData?.flashSale?.quantity - addToCartData?.flashSale?.soldQuantity} sản phẩm`, {
              position: 'bottom-center',
              icon: <IconErrorMessage />,
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: 'dark',
            })
          return false
        }
      }
    }
    return true;
  }

  const groupButton = useMemo(() => {
    if (
      addToCartData.stockStatus === ProductStockStatus.OUT_OF_STOCK &&
      !addToCartData.flashSale
    ) {
      return (
        <ProductButton
          type={AddToCartType.CONTACT}
          onClick={() => setIsOpenContact && setIsOpenContact(true)}
          isProcessing={cartLoading}
        />
      )
    }

    if (addToCartData.stockStatus === ProductStockStatus.OUT_OF_BUSINESS) {
      return (
        <ProductButton
          type={AddToCartType.OUT_OF_BUSINESS}
          onClick={() => true}
          isProcessing={cartLoading}
        />
      )
    }
    if (addToCartData.preOrder && isPreOrder) {
      return (
        <ProductButton
          type={AddToCartType.PRE_ORDER}
          date={addToCartData?.preOrder?.deliveredAfter}
          isPreOrderButton={isPreOrder}
          second={`(${dataProduct?.preOrder?.salePrice.toLocaleString(selectedLang as string, {
            style: 'currency',
            currency: currency(selectedLang as string),
          })
          .replace(/\s₫/g, 'đ')})`}
          onClick={() => {
            handleAddToCart(dataProduct, AddToCartType.PRE_ORDER).then(res => {
              if (res instanceof Error && res) {
                if (res?.message == API_STATUS_CODE.PRODUCT_LIMIT_SALE || res?.message == API_STATUS_CODE.PRODUCT_LIMIT_FS_SALE) {
                  router.push(`/checkout/cart`)
                }
              }
              return res
            })
          }}
          isProcessing={cartLoading}
        />
      )
    }
    return (
      <div className='entry-action-top flex justify-between w-full gap-2'>
        <ProductButton
          type={AddToCartType.ADD}
          onClick={() => {
            if(!checkFSSale()) {
              return;
            }
            if (listBundleSelected && listBundleSelected.length > 0) {
              handleAddBundleToCart(listBundleProduct, AddToCartType.ADD).then(
                res => {
                  if (res instanceof Error && res) {
                    fetchCart()
                    if (res?.message == API_STATUS_CODE.PRODUCT_LIMIT_SALE || res?.message == API_STATUS_CODE.PRODUCT_LIMIT_FS_SALE) {
                      router.push('/checkout/cart')
                    }
                  }
                }
              )
            }
            handleAddToCart(dataProduct, AddToCartType.ADD).then(res => {
              if (res instanceof Error && res) {
                fetchCart()
                if (res?.message == API_STATUS_CODE.PRODUCT_LIMIT_SALE || res?.message == API_STATUS_CODE.PRODUCT_LIMIT_FS_SALE) {
                  router.push('/checkout/cart')
                }
              }
              toast.success('Sản phẩm đã được thêm vào giỏ hàng', {
                position: 'bottom-center',
                icon: <IconCheckedSuccess />,
                autoClose: 1500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: 'dark',
              })
            })
          }}
          isProcessing={cartLoading}
        />
        {isInstallment && channel === SaleChannel.B2C && (
          <ProductButton
            type={AddToCartType.INSTALLMENT}
            onClick={() => {
              if(!checkFSSale()) {
                return;
              }
              handleAddToCart(dataProduct, AddToCartType.INSTALLMENT).then(
                res => {
                  if (res instanceof Error && res) {
                    if (res?.message == API_STATUS_CODE.PRODUCT_LIMIT_SALE || res?.message == API_STATUS_CODE.PRODUCT_LIMIT_FS_SALE) {
                      router.push(`/checkout/cart`)
                    }
                  }
                  return res
                }
              )
            }}
            second= {`(Từ ${
              (addToCartData?.finalPrice / 6)
                  .toLocaleString(selectedLang as string, {
                    style: 'currency',
                    currency: currency(selectedLang as string),
                  })
                  .replace(/\s₫/g, 'đ')
            })`}
          />
        )}
        <ProductButton
          type={AddToCartType.BUY_NOW}
          second={`(${finalPriceButton().toLocaleString(selectedLang as string, {
                    style: 'currency',
                    currency: currency(selectedLang as string),
                  })
                  .replace(/\s₫/g, 'đ')})`}
          onClick={() => {

            if (!token && dataProduct?.coupons?.length > 0) {
              setIsVoucherLoginOpen(true)
              setVoucherChoose(dataProduct?.coupons[0] as VoucherItem)
              return
            }
            if (token && dataProduct.coupons?.length == 1) {
              const coupon = dataProduct?.coupons[0]
              if (coupon.target == 'product') {
                setVoucherApply([
                  dataProduct.coupons[0].code + '_' + dataProduct._id,
                ])
              }
              if (coupon.target == 'order') {
                setVoucherApply([dataProduct.coupons[0].code + '_orderCoupon'])
              }
            }
            if (listBundleSelected && listBundleSelected?.length > 0) {
              handleAddBundleToCart(
                listBundleProduct,
                AddToCartType.BUY_NOW
              ).then(res => {
                if (res instanceof Error && res) {
                  console.log(res?.message)
                  fetchCart()
                  if (res?.message == API_STATUS_CODE.PRODUCT_LIMIT_SALE || res?.message == API_STATUS_CODE.PRODUCT_LIMIT_FS_SALE) {
                    router.push('/checkout/cart')
                  }
                }
              })
            }

            handleAddToCart(dataProduct, AddToCartType.BUY_NOW).then(res => {
              if (res instanceof Error || !res) {
                fetchCart()
                if (res?.message == API_STATUS_CODE.PRODUCT_LIMIT_SALE || res?.message == API_STATUS_CODE.PRODUCT_LIMIT_FS_SALE) {
                  router.push('/checkout/cart')
                }
              }
            })
          }}
          isProcessing={cartLoading}
        />
      </div>
    )
  }, [addToCartData, cartLoading, dataProduct])

  return (
    <div
      className={`footer-detail w-full flex flex-wrap justify-center fixed bottom-0 left-[50%] z-[999] max-w-[440px] translate-x-[-50%] bg-white shadow-top p-2 h-[70px] items-center`}
    >

      <div className='flex justify-between items-center w-full'>
        <div className='a2c-action w-full flex gap-2'>{groupButton}</div>
      </div>
    </div>
  )
}
export default FooterProductDetail
